import { useToast } from 'vue-toastification';

const toast = useToast();

// initial state
const state = () => ({
    partyRoomChannel: null,
    roomData: {
        active: false,
        users: []
    }
})

// getters
const getters = {
    //
}

// actions
const actions = {
    createPartyRoom: async ({ commit }) => {
        return axios.post('party').then(({ data }) => {
            return data;
        }).catch(({ response }) => {
            toast.error(response.data?.message || "An error occurred, please try again.");
            throw response.data?.message || "An error occurred, please try again.";
        });
    },

    refreshPartyRoom: async ({ commit }, roomId) => {
        return axios.put('party/' + roomId, {
            refresh: true
        }).then(({ data }) => {
            return data;
        }).catch(({ response }) => {
            toast.error(response.data?.message || "An error occurred, please try again.");
            throw response.data?.message || "An error occurred, please try again."
        });
    },

    startBroadcast: async ({ commit }, roomId) => {
        return axios.put('party/' + roomId, {
            broadcast: true
        }).then(({ data }) => {
            commit('setPartyRoom', data.key);
            toast.success("Broadcast started successfully.");
            return data;
        }).catch(({ response }) => {
            toast.error(response.data?.message || "An error occurred, please try again.");
            throw response.data?.message || "An error occurred, please try again."
        });
    },

    stopBroadcast: async ({ commit }, roomId) => {
        return axios.put('party/' + roomId, {
            broadcast: false
        }).then(({ data }) => {
            commit('resetPartyRoom');
            return data;
        }).catch(({ response }) => {
            toast.error(response.data?.message || "An error occurred, please try again.");
            throw response.data?.message || "An error occurred, please try again."
        });
    },

    broadcastTrackAction: async ({ commit }, payload) => {
        return axios.post('party/' + payload.room_key + '/track-action', payload).then(({ data }) => {
            return data;
        }).catch(({ response }) => {
            throw response.data?.message || "An error occurred, please try again.";
        });
    }
}

// mutations
const mutations = {
    setPartyRoom(state, data) {
        state.partyRoomChannel = data;
    },

    resetPartyRoom(state) {
        state.partyRoomChannel = null;
    },

    addPartyMember(state, name) {
        state.roomData.users.push(name);
    },

    removePartyMember(state, name) {
        state.roomData.users = state.roomData.users.filter(u => u !== name);
    },

    setRoomActivity(state, active) {
        state.roomData.active = active;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
